import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { GeneratedArtifact } from '../data/artifact';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { SpeechRecArtifact } from '../data/student-artifact';
import { FormatUtilities } from '../utilities/format-utilities';
import { DataService } from '../data/data.service';
import { BundledResponses, CreatorType } from '../data/daisychain';
import videojs from 'video.js';

@Component({
  selector: 'app-artifact-display-speech-rec',
  templateUrl: './artifact-display-speech-rec.component.html',
  styleUrls: ['./artifact-display-speech-rec.component.scss']
})
export class ArtifactDisplaySpeechRecComponent implements OnInit {
  constructor(private dataService: DataService, private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) { }

  @Input() artifact: GeneratedArtifact;
  static currentlyPlayingAudio: any;
  longDateFormat = FormatUtilities.longDateFormat;
  get loaded(): boolean { return !!this.artifact.Data; }

  bundledResponses: BundledResponses[];
  @ViewChild('responsesContainer') responsesContainer: ElementRef;
  hasOverflow: boolean = false;

  ngOnInit() {
    if (!this.artifact.Data) {
      this.dataService.getArtifact(this.artifact.StudentID, this.artifact.ArtifactID, this.artifact.StartedActivityID).subscribe(r2 => {
        this.artifact.Data = r2;
        setTimeout(() => this.checkOverflow(), 0);
      });
    }
    else {
      setTimeout(() => this.checkOverflow(), 0);
    }
  }

  checkOverflow() {
    if (this.responsesContainer) {
      const container = this.responsesContainer.nativeElement;
      this.hasOverflow = container.scrollHeight > container.clientHeight;
      this.cdr.detectChanges();
    }
  }

  playArtifactAudio(audioPlayer) {
    if (audioPlayer.paused) {
      if (ArtifactDisplaySpeechRecComponent.currentlyPlayingAudio) {
        ArtifactDisplaySpeechRecComponent.currentlyPlayingAudio.pause();
        ArtifactDisplaySpeechRecComponent.currentlyPlayingAudio.currentTime = 0;
      }
      ArtifactDisplaySpeechRecComponent.currentlyPlayingAudio = audioPlayer;
      audioPlayer.play()
    }
    else {
      audioPlayer.pause();
      audioPlayer.currentTime = 0;
    }
  }

  getArtifactBinary(): SafeResourceUrl {
    if (this.artifact.Data) {
      const speechRecData = this.artifact.Data as unknown as SpeechRecArtifact;
      if (speechRecData.Attempts && speechRecData.Attempts[0].Recording) {
        const binary = speechRecData.Attempts[0].Recording;
        const unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(binary)], { type: 'audio/mp3' }));
        return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
      }
    }
    return '';
  }

  convertEncodedDataToBinary(base64): Uint8Array {
    if (base64) {
      const raw = window.atob(base64);
      const rawLength = raw.length;
      const array = new Uint8Array(new ArrayBuffer(rawLength));
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    }
    return new Uint8Array();
  }

  getSortedResponses(): string[] {
    if (this.artifact.Data?.Attempts?.length > 0) {
      const allTargetPhrases = new Set<string>();
      this.artifact.Data.Attempts.forEach(attempt => {
        if (attempt.TargetPhrases) {
          attempt.TargetPhrases.forEach(phrase => allTargetPhrases.add(phrase));
        }
      });
      
      if (allTargetPhrases.size > 0) {
        return Array.from(allTargetPhrases).sort((a, b) => a.localeCompare(b));
      }
    }
    
    if (this.artifact.SpeechRecPromptMetadata?.SpeechRecTargets) {
      return this.artifact.SpeechRecPromptMetadata.SpeechRecTargets
        .split('|')
        .sort((a, b) => a.localeCompare(b));
    }
    return [];
  }

  isAnyAttemptCorrect(): boolean {
    return this.artifact.Data?.Attempts?.some(attempt => attempt.WasMarkedCorrect) ?? false;
  }

  getAttemptAudioUrl(attempt: any): SafeResourceUrl {
    if (attempt.Recording) {
      const unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(attempt.Recording)], { type: 'audio/mp3' }));
      return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
    }
    return '';
  }
} 